import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Row, Col, Image } from 'react-bootstrap';
import PaymentServices from 'services/payment';
import { routers } from 'router/router';
import { useHistory } from 'react-router';
import ReuseLoginLayout from 'components/layout/ReuseLoginLayout';
import SelectInput from 'components/input/SelectInput';
import Cookies from 'js-cookie';
// import { authenticateSettings } from 'components/helper/appConfig';
import { redirectProgram } from 'screen/common/RedirectHelper';
import { clearAuthData, getAccessToken, removeAccessToken, setAccessToken } from 'utils/sessionStorage';
import { useAppDispatch } from 'app/hooks';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';

interface Props {}

const SuccessPage = (props: Props) => {
  let history = useHistory();
  const dispatch = useAppDispatch();
  const [session, setSession] = useState({});
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  // Token of the session that started the checkout. The page drops it from
  // sessionStorage on mount (public page), but we keep it here so the Login
  // button can still revoke that session on the backend before re-login.
  const previousTokenRef = useRef<string | undefined>(undefined);
  const location = useLocation();
  const sessionId = location.search.replace('?session_id=', '');

  useEffect(() => {
    if (previousTokenRef.current === undefined) {
      previousTokenRef.current = getAccessToken();
    }
    removeAccessToken();
    async function fetchSession() {
      const session = await PaymentServices.checkoutStripSession(sessionId);
      setSession(session);

      let redirectId = Cookies.get('redirectId') ?? '';
      let catId = Cookies.get('catId') ?? '';
      await redirectProgram(redirectId, catId);
    }
    fetchSession();
  }, [sessionId]);

  console.log('session', session);

  // Log out the current session first, then go to the login page, so the
  // student signs in again and gets a fresh session with the new plan.
  const handleLogin = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    try {
      const previousToken = previousTokenRef.current;
      if (previousToken) {
        // Restore the token so the logout thunk can revoke it on the backend
        setAccessToken(previousToken);
        await dispatch(logout());
      }
    } catch (ex) {
      console.error('Error during logout before login:', ex);
    } finally {
      // Always clear local auth data, even if the logout API failed
      clearAuthData();
      previousTokenRef.current = '';
      setIsLoggingOut(false);
      history.replace(routers.login.path);
    }
  };

  return (
    <ReuseLoginLayout>
      <div className="d-flex mx-3 flex-wrap pb-md-5 mb-md-5 justify-content-between align-items-center">
        <span>
          <SelectInput
            values={'English (USA)'}
            borderless
            mdCol={'12'}
            option={['English (USA)']}
          />
        </span>
        <span className="mt-2">
          <span> Already a member ?</span>
          <Button
            className="p-0 mx-1 pb-1"
            disabled={isLoggingOut}
            onClick={handleLogin}
            variant="link"
          >
            Login
          </Button>
        </span>
      </div>
      <Row className="p-0 m-0">
        <Col xs={12} md={8} className="p-0 text-center">
          <div className="PaymentSuccess-iconContainer flex-item width-grow mb-3">
            <Image src={'/assets/images/confirm-check.png'} height={'80px'}/>
          </div>

          <h2 className="m-3 mt-4">Your payment has successfully been processed.</h2>

          <div className="m-3">
            <h5>Please log into your account.</h5>
          </div>

          <Button
              className="w-25 p-3 m-3"
              variant="primary"
              disabled={isLoggingOut}
              onClick={handleLogin}
            >
              <span className="h5 fw-bold">Login</span>
            </Button>
        </Col>
      </Row>     
    </ReuseLoginLayout>
  );

};

export default SuccessPage;
